import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Footnote4 extends ITextBoxProps {}

export const TextBoxMaxLine1Footnote4 = ({
  title = '',
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Footnote4,
  alignment = TextAligning.Center,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Footnote4): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
